import React, { useState } from "react";

import styled from "styled-components";
import { About } from "../Styles";
import Toggle from "./Toggle";
import { AnimateSharedLayout } from "framer-motion";

const FaqSection = () => {
  const [faqToggle, setFaqToggle] = useState(false);
  return (
    <Faq>
      <h2>Any Question</h2>
      <AnimateSharedLayout>
        <Toggle title="How do I start ?">
          <div className="answer">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos quo
              ex quas similique beatae possimus excepturi natus inventore
              obcaecati perferendis aliquid alias, doloribus, pariatur veritatis
              nihil velit quae eligendi aliquam.
            </p>
          </div>
        </Toggle>
        <Toggle title="Our Tech">
          <div className="answer">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos quo
              ex quas similique beatae possimus excepturi natus inventore
              obcaecati perferendis aliquid alias, doloribus, pariatur veritatis
              nihil velit quae eligendi aliquam.
            </p>
          </div>
        </Toggle>
        <Toggle title="Research and development">
          <div className="answer">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos quo
              ex quas similique beatae possimus excepturi natus inventore
              obcaecati perferendis aliquid alias, doloribus, pariatur veritatis
              nihil velit quae eligendi aliquam.
            </p>
          </div>
        </Toggle>
        <Toggle title="Money Talk">
          <div className="answer">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos quo
              ex quas similique beatae possimus excepturi natus inventore
              obcaecati perferendis aliquid alias, doloribus, pariatur veritatis
              nihil velit quae eligendi aliquam.
            </p>
          </div>
        </Toggle>
      </AnimateSharedLayout>
    </Faq>
  );
};

const Faq = styled(About)`
  display: block;
  span {
    display: block;
  }
  h2 {
    padding-bottom: 2rem;
    font-weight: lighter;
  }
  .faq-line {
    background: #cccccc;
    height: 0.2rem;
    margin: 0.2rem;
    width: 100%;
  }
  .question {
    padding: 3rem 0rem;
    cursor: pointer;
  }
  .answer {
    padding: 2rem 0rem p {
      padding: 1rem 0rem;
    }
  }
`;

export default FaqSection;
